import { render, staticRenderFns } from "./ObtaclesConfig.vue?vue&type=template&id=01fd5849&scoped=true&"
import script from "./ObtaclesConfig.vue?vue&type=script&lang=js&"
export * from "./ObtaclesConfig.vue?vue&type=script&lang=js&"
import style0 from "./ObtaclesConfig.vue?vue&type=style&index=0&id=01fd5849&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fd5849",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01fd5849')) {
      api.createRecord('01fd5849', component.options)
    } else {
      api.reload('01fd5849', component.options)
    }
    module.hot.accept("./ObtaclesConfig.vue?vue&type=template&id=01fd5849&scoped=true&", function () {
      api.rerender('01fd5849', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/game/sunset-drive/components/ObtaclesConfig.vue"
export default component.exports